module.exports = __webpack_public_path__ + "img/commercial_05_precision.9dd384f4.svg";